module.exports = __webpack_public_path__ + "img/venta_2.b0210917.svg";